import { AuthorizationWrapper } from '@frontend/authorization';
import { EntityType, Rights } from '@frontend/common';
import { MultiSelectInputV2 } from '@frontend/components/basic-forms';
import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import useAccountInitialize from './account-initialize.controller';

export const AccountInitialize = () => {
    const viewProps = useAccountInitialize();
    return (
        <div className='card mt-3 w-full lg:w-1/2'>
            <div className='card-body'>
                <div className='flex flex-col'>
                    <div className='flex flex-col gap-2'>
                        <MultiSelectInputV2
                            options={viewProps.applications.map((app) => ({
                                label: app.charAt(0).toUpperCase() + app.slice(1).replace(/_/g, ' '),
                                value: app
                            }))}
                            label={
                                <FormattedMessage
                                    id='account-initialize.applications'
                                    defaultMessage='Applications'
                                    description='Applications label on the account initialization page'
                                />
                            }
                            value={viewProps.initializeOptions.applications}
                            onSelect={(apps) => viewProps.setInitializeOptions((prev) => ({ ...prev, applications: apps?.map((v) => v.value) || [] }))}
                            disableSearch
                        />
                        <AuthorizationWrapper
                            requiredPermissions={[{ item: EntityType.ACCOUNT, source: EntityType.ACCOUNT, right: Rights.SUPER_ADMIN, uid: '*' }]}>
                            <MultiSelectInputV2
                                options={viewProps.customers.map((app) => ({
                                    label: app.charAt(0).toUpperCase() + app.slice(1).replace(/_/g, ' '),
                                    value: app
                                }))}
                                label={
                                    <FormattedMessage
                                        id='account-initialize.customers'
                                        defaultMessage='Customers'
                                        description='Customers label on the account initialization page'
                                    />
                                }
                                value={viewProps.initializeOptions.customers}
                                onSelect={(apps) => viewProps.setInitializeOptions((prev) => ({ ...prev, customers: apps?.map((v) => v.value) || [] }))}
                                disableSearch
                            />
                        </AuthorizationWrapper>
                    </div>
                </div>
            </div>
            <div className='card-footer flex justify-between'>
                <DefaultSecondaryButton
                    onClick={viewProps.onCancel}
                    text={CommonMessage.BUTTONS.CANCEL}
                />
                <DefaultPrimaryButton
                    onClick={viewProps.onSubmit}
                    text={CommonMessage.BUTTONS.SUBMIT}
                />
            </div>
        </div>
    );
};
